<template>
  <div>
    <p class="mb-4">
      Apply a discount code here. Gift cards and account balances can be applied
      on the payment step.
    </p>
    <ApplyDiscountCode />
  </div>
</template>
